import request from '@/utils/request'

const baseUrl = '/erp/customer/category'

/** 维护用全量目录树（含停用） */
export function treeCustomerCategory () {
  return request({
    url: baseUrl + '/tree',
    method: 'get'
  })
}

/** 新建目录节点 */
export function addCustomerCategory (data) {
  return request({
    url: baseUrl + '/add',
    method: 'post',
    data
  })
}

/** 编辑目录节点 */
export function editCustomerCategory (data) {
  return request({
    url: baseUrl + '/edit',
    method: 'post',
    data
  })
}

/** 启用 */
export function enableCustomerCategory (id) {
  return request({
    url: baseUrl + '/enable',
    method: 'post',
    data: { id }
  })
}

/** 停用 */
export function disableCustomerCategory (id) {
  return request({
    url: baseUrl + '/disable',
    method: 'post',
    data: { id }
  })
}

/** 删除 */
export function deleteCustomerCategory (id) {
  return request({
    url: baseUrl + '/delete',
    method: 'post',
    data: { id }
  })
}
